<template>
  <div>
    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading ...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <p v-if="state.noData">No Data</p>

    <main
      class="report"
      v-if="!state.noData && !state.loading"
      id="section-print"
    >
      <div class="header">
        <h2 class="report-title">LAPORAN TTB BELUM INVOICE</h2>
        <p class="text--secondary">
          Hanya menampilkan TTB yang sudah memiliki Kapal
        </p>
      </div>

      <table width="100%" class="mt-4 mb-2">
        <thead>
          <th class="text-left">Kode TTB</th>
          <th class="text-left">No TTB</th>
          <th class="text-left">Tgl</th>
          <th class="text-left">Pengirim</th>
          <th class="text-left">Penerima</th>
          <th class="text-left">Nama Kapal</th>
          <th class="text-left">Voyage</th>
          <th class="text-left">Tgl Berangkat</th>
        </thead>
        <tbody>
          <tr v-for="ttb in data" :key="ttb.id">
            <td>{{ ttb.kodettb }}</td>
            <td>{{ ttb.nottb || "-" }}</td>
            <td>{{ formatDate(ttb.tgl) }}</td>
            <td>
              {{
                ttb.pengirim_detil
                  ? ttb.pengirim_detil.nama ||
                    ttb.pengirim_detil.nama_lengkap ||
                    "-"
                  : "-"
              }}
            </td>
            <td>
              {{
                ttb.penerima_detil
                  ? ttb.penerima_detil.nama ||
                    ttb.penerima_detil.nama_lengkap ||
                    "-"
                  : "-"
              }}
            </td>
            <td>{{ ttb.nama_kapal || "-" }}</td>
            <td>{{ ttb.voy || "-" }}</td>
            <td>{{ formatDate(ttb.tgl_berangkat) }}</td>
          </tr>
        </tbody>
      </table>
    </main>

    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      v-if="!state.noData && !state.loading"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      state: {
        loading: false,
        noData: false
      },
      data: []
    };
  },
  methods: {
    async fetchData() {
      this.state.loading = true;

      await axios
        .get("laporan/ttb-belum-invoice")
        .then(res => {
          if (!res.data || res.data.length === 0) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
            this.data = res.data;
          }
          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;
          alert(err.response?.data?.message || "Gagal memuat laporan");
        });
    },
    formatDate(date) {
      if (!date) return "-";
      const d = new Date(date);
      if (Number.isNaN(d.getTime())) return "-";
      return `${String(d.getDate()).padStart(2, "0")}-${String(
        d.getMonth() + 1
      ).padStart(2, "0")}-${d.getFullYear()}`;
    },
    printDocument() {
      window.print();
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

table th {
  text-align: left;
}
</style>
